mutation deleteUser($id: ID!) {
  deleteUser(id: $id)
}
